import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchParams: {
    tripType: "oneway",
    adults: 1,
    children: 0,
    infants: 0,
    cabin: "economy",
    studentFare: false,
    armedForces: false,
    seniorCitizen: false,
    directOnly: false,
    refundableOnly: false,
    nearbyAirports: true,
    preferredAirlines: "",
    fromAirport: null, // { code, label }
    toAirport: null,
    departureDate: "",
    returnDate: "",
    legs: [], // multi-city: [{ fromAirport, toAirport, departureDate }]
  },
  bootstrap: null, // dropdown_options / special_fares / popular_routes from search/home
  isSearching: false, // true while /flights/search is in flight
  results: null, // { tui, currency, flights, legs, search_summary }
  selectedFlight: null, // the flight card the user clicked "Book" on (OW) or onward (RT)
  roundTrip: null, // RT handoff: { trip_type, onward_flight, return_flight, onward_fares, return_fares, ... }
  review: null, // { fare_types } from fare-group-details
  selectedFareIndex: null,
  selectedOnwardFareIndex: 0,
  selectedReturnFareIndex: 0,
  selectedAddOns: {}, // { "FUID-PaxID-category": ssrOptionSelection }
  bookingContext: null, // { priced_tui, search_selection, fare_summary, total_label, ssr } stashed for the booking step
};

const flightSearchSlice = createSlice({
  name: "flightSearch",
  initialState,
  reducers: {
    setSearchParams: (state, action) => {
      Object.assign(state.searchParams, action.payload);
    },
    setBootstrap: (state, action) => {
      state.bootstrap = action.payload;
    },
    setFlightSearching: (state, action) => {
      state.isSearching = action.payload;
    },
    setResults: (state, action) => {
      state.results = action.payload;
    },
    setSelectedFlight: (state, action) => {
      state.selectedFlight = action.payload;
      state.roundTrip = null;
      state.review = null;
      state.selectedFareIndex = null;
      state.selectedOnwardFareIndex = 0;
      state.selectedReturnFareIndex = 0;
      state.selectedAddOns = {};
    },
    setRoundTripSelection: (state, action) => {
      state.roundTrip = action.payload;
      state.selectedFlight = action.payload?.onward_flight
        ? {
            ...action.payload.onward_flight,
            route_type: action.payload.route_type,
            flight_fares: action.payload.onward_fares,
          }
        : null;
      state.review = null;
      state.selectedFareIndex = null;
      state.selectedOnwardFareIndex = Number(action.payload?.selected_onward_index) || 0;
      state.selectedReturnFareIndex = Number(action.payload?.selected_return_index) || 0;
      state.selectedAddOns = {};
    },
    setReview: (state, action) => {
      state.review = action.payload;
    },
    setSelectedFareIndex: (state, action) => {
      state.selectedFareIndex = action.payload;
    },
    setSelectedOnwardFareIndex: (state, action) => {
      state.selectedOnwardFareIndex = action.payload;
    },
    setSelectedReturnFareIndex: (state, action) => {
      state.selectedReturnFareIndex = action.payload;
    },
    setSelectedAddOns: (state, action) => {
      state.selectedAddOns = action.payload;
    },
    setBookingContext: (state, action) => {
      state.bookingContext = action.payload;
    },
    resetFlightSearch: () => initialState,
  },
});

export const {
  setSearchParams,
  setBootstrap,
  setFlightSearching,
  setResults,
  setSelectedFlight,
  setRoundTripSelection,
  setReview,
  setSelectedFareIndex,
  setSelectedOnwardFareIndex,
  setSelectedReturnFareIndex,
  setSelectedAddOns,
  setBookingContext,
  resetFlightSearch,
} = flightSearchSlice.actions;

export default flightSearchSlice.reducer;
